






































































import Vue from 'vue'
import Component from 'vue-class-component'
import {IconDefinition, faArrowLeft, faPencilAlt} from '@fortawesome/free-solid-svg-icons'
import { ColorTheme, CompanyModel, ChangeCompanyStatusModel, StatusType, SubscriptionUpdateModel } from '@/services/types'
import {StoreActionTypes} from '@/store/types'
import CreateCompanyEmployeeModalForm from '@/components/form/CreateCompanyEmployeeModalForm.vue'
import FormInput from '@/components/lib/input/FormInput.vue'
import ActionButton from '@/components/lib/button/ActionButton.vue'
import ModalComponent from '@/components/modal/ModalComponent.vue'
import ConfirmationComponent from '@/components/modal/ConfirmationComponent.vue'
import SubscriptionForm  from '@/components/form/SubscriptionForm.vue'

@Component({
	components: {
		FormInput,
		ActionButton,
		CreateCompanyEmployeeModalForm,
		ModalComponent,
		ConfirmationComponent,
		SubscriptionForm
	},
	watch: {
		'$store.getters.getCompaniesSelectedCompany': 'setEditedCompanyName'
	}
})
export default class CompanyDetailsHeader extends Vue {
	private componentClass = "CompanyDetailsHeader"
	private back: IconDefinition = faArrowLeft
	private edit: IconDefinition = faPencilAlt
	private showChangeCompanyNameForm = false
	private editedCompanyName = ''
	private changeStatusCompanyConfirmationShow = false
	private showCompanySubscriptionForm = false

	mounted() {
		this.setEditedCompanyName()
	}

	getCompanyStatus(): StatusType {
		return (this.$store.getters.getCompaniesSelectedCompany as CompanyModel) ? (this.$store.getters.getCompaniesSelectedCompany as CompanyModel).status : null
	}

	get companyName() {
		return (this.$store.getters.getCompaniesSelectedCompany as CompanyModel) ? (this.$store.getters.getCompaniesSelectedCompany as CompanyModel).name : ''
	}

	get statusDropdownTitle() {
		return this.getCompanyStatus() == 'ACTIVE' ? 'Активна' : 'Не активна'
	}

	get statusDropdownItemTitle() {
		return this.getCompanyStatus() == 'ACTIVE' ? 'Деактивировать' : 'Активировать'
	}

	get statusDropdownItemVariant(): ColorTheme {
		return this.getCompanyStatus()  == 'ACTIVE' ? 'success' : 'warning'
	}

	get modalChangeCompanyNameFormDisabled() {
		return this.disabled || this.editedCompanyName.length < 3
	}

	get disabled (){
		return this.$store.getters.isCompaniesDataLoading
	}

	get subscriptionDisabled (): boolean {
		return this.$store.getters.isSubscriptionDataLoading
	}

	handleEditCompanyNameIconClick() {
		this.showChangeCompanyNameForm = !this.showChangeCompanyNameForm
	}
	
	companyNameChange(text: string) {
		this.editedCompanyName = text
	} 

	async handleModalChangeCompanyNameFormOkBtnClick() {
		await this.editCompanyName()
		this.handleEditCompanyNameIconClick()
	}

	async editCompanyName() {
		await this.$store.dispatch(StoreActionTypes.SET_COMPANIES_COMPANY_CHANGE_NAME, this.editedCompanyName)
	}

	handleBackIconClick() {
		this.$store.dispatch(StoreActionTypes.SET_COMPANIES_SELECTED_COMPANY_CLEAR)
		this.$router.push('/companies')
	}

	setEditedCompanyName() {
		this.editedCompanyName = (this.$store.getters.getCompaniesSelectedCompany as CompanyModel) ? (this.$store.getters.getCompaniesSelectedCompany as CompanyModel).name : ''
	}

	handleChangeStatusItemClick() {
		this.changeStatusCompanyConfirmationShow = true
	}

	async changeCompanyStatus() {
        const model: ChangeCompanyStatusModel = {
			id: (this.$store.getters.getCompaniesSelectedCompany as CompanyModel).id,
			status: (this.$store.getters.getCompaniesSelectedCompany as CompanyModel).status 
		}
		await this.$store.dispatch(StoreActionTypes.SET_COMPANIES_COMPANY_CHANGE_STATUS, model)

        this.changeCompanyStatusCancel()
    }

	changeCompanyStatusCancel() {
        this.changeStatusCompanyConfirmationShow = false
    }

	get setChangeStatusConfirmationOkBtnVariant() {
        return this.getOkBtnVariant(
            this.getCompanyStatus()
        )
    }
    
    getOkBtnVariant(status: StatusType): ColorTheme {
        return status == 'ACTIVE' ? 'danger' : 'success'
    }

	async handleCompanySubscriptionBtn () {
		this.$store.dispatch(StoreActionTypes.SET_SUBSCRIPTION_DATA_CLEAR)
		this.showCompanySubscriptionForm = !this.showCompanySubscriptionForm
	}

	async handleModalCompanySubscriptionFormOkBtnClick() {
		const model: SubscriptionUpdateModel = (this.$refs.subscriptionForm as SubscriptionForm).getSubscriptionUpdateModel()
		await this.$store.dispatch(StoreActionTypes.SET_SUBSCRIPTION_UPDATE, model)
		this.showCompanySubscriptionForm = !this.showCompanySubscriptionForm		
	}
}
